import AHRISystemToolDataCustomState from "@crescentParts/Store/Data/AHRISystemData/AHRISystemDataState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";

import { Draft } from "immer";

const initialState = {
    ahriData: {},
    ahriPagination: {},
    ahriDataLoading: false,
    ahriSorting: "",
    attributes: {}

};

interface KeyValueModel {
    [key: string]: any
}

const reducer = {
    "Custom/AHRISystemToolConfigData/fetchData":(draft:Draft<AHRISystemToolDataCustomState>,action:{ ahriData: any, ahriPagination: any },)=>{
        draft.ahriData = action.ahriData
        draft.ahriPagination = action.ahriPagination
        draft.ahriDataLoading = false
    },
    "Custom/AHRISystemToolConfigData/ahriSorting":(draft:Draft<AHRISystemToolDataCustomState>,action:{ ahriSorting: string },)=>{
        draft.ahriSorting = action.ahriSorting
    },
    "Custom/AHRISystemToolConfigData/attributes":(draft:Draft<AHRISystemToolDataCustomState>,action:{ attributes: KeyValueModel },)=>{
        draft.attributes = action.attributes
    }
}

export default createTypedReducerWithImmer(initialState, reducer);